import React, { useEffect, useState } from 'react';

interface VideoPreloaderProps {
  videoRef: React.RefObject<HTMLVideoElement>;
  setLoaded: (value: boolean) => void;
  src: string;
}

const VideoPreloader: React.FC<VideoPreloaderProps> = ({ videoRef, setLoaded, src }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const video = document.createElement('video');
    video.src = src;
    video.preload = 'auto';

    const updateProgress = () => {
      try {
        if (video.buffered.length > 0) {
          const bufferedEnd = video.buffered.end(video.buffered.length - 1);
          const duration = video.duration || 1;
          const percent = Math.min((bufferedEnd / duration) * 100, 100);
          setProgress(Math.floor(percent));

          if (percent >= 100) {
            setLoaded(true);
          }
        }
      } catch (err) {
        // fallback: marca como carregado após um tempo
        setTimeout(() => setLoaded(true), 1500);
      }
    };

    video.addEventListener('progress', updateProgress);
    video.addEventListener('canplaythrough', () => setLoaded(true));
    video.addEventListener('loadeddata', updateProgress);

    return () => {
      video.removeEventListener('progress', updateProgress);
    };
  }, [src, setLoaded]);

  return (
    <div className="w-full h-[200px] flex flex-col items-center justify-center bg-black text-white">
      <p className="mb-2 text-sm">Carregando vídeo...</p>
      <div className="w-[80%] h-2 bg-gray-600 rounded overflow-hidden">
        <div
          className="bg-[#52432f] h-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="text-sm mt-2">{progress}%</p>
    </div>
  );
};

export default VideoPreloader;
